import {Component, OnInit, Inject, AfterViewInit} from '@angular/core';
import {PatientsManagerService} from "../patients-manager.service";
import {ApiRequestService} from "../api-request.service";

@Component({
  selector: 'taxihandgo-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  tracesUrl: string;

  constructor(
    @Inject("patients") public patientsManager: PatientsManagerService,
    @Inject("apiRequest") private apiRequest: ApiRequestService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.tracesUrl = this.apiRequest.getTracesUrl();
    console.log(this.tracesUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts